import React from 'react';
import { Box } from '@mui/material';
import { faUserLock } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColorPalette } from '../../../components/config';

export function RestrictedCitizenLabel({ dense = false }: { dense?: boolean }) {
  return (
    <Box display="flex" alignItems="center" gap={dense ? 1 : 3} sx={{ color: 'text.secondary' }}>
      <FontAwesomeIcon icon={faUserLock} color={ColorPalette.DeepGalaxy} size={dense ? '1x' : 'lg'} />
      Du har ikke adgang til at se denne borger
    </Box>
  );
}
